
import { useState, useEffect } from "react";

interface CalculationValues {
  valorGeracaoEstimada: number;
  payback: string;
  valorKwhMes: string;
}

export const useGeradorCalculations = (
  geracaoEstimada: number,
  tarifaVenda: number,
  custoInvestimento: number
): CalculationValues => {
  const [calculations, setCalculations] = useState<CalculationValues>({
    valorGeracaoEstimada: 0,
    payback: "N/A",
    valorKwhMes: "N/A"
  });

  useEffect(() => {
    const valorGeracaoEstimada = geracaoEstimada * tarifaVenda || 0;
    
    const payback = valorGeracaoEstimada > 0 
      ? (custoInvestimento / (valorGeracaoEstimada * 12)).toFixed(2) 
      : "N/A";
    
    const valorKwhMes = geracaoEstimada > 0 
      ? (custoInvestimento / (geracaoEstimada * 12 * 25)).toFixed(4) 
      : "N/A";

    setCalculations({
      valorGeracaoEstimada,
      payback,
      valorKwhMes
    });
  }, [geracaoEstimada, tarifaVenda, custoInvestimento]);

  return calculations;
};
